import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03f74c78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = {
  class: "card-title",
  style: {"display":"flex"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 更新值班数据 ")
const _hoisted_8 = { class: "card-body table-responsive p-0" }
const _hoisted_9 = {
  key: 0,
  class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center"
}
const _hoisted_10 = { ref: "tableTr" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ID", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "批次", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "工号", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "姓名", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "余额", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "normal-width text-left" }, "使用时长", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "创建姓名", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "创建时间", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "修改姓名", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "修改时间", -1))
const _hoisted_21 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["colspan"]
const _hoisted_24 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_25 = { class: "text-left" }
const _hoisted_26 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_app_select_from_db = _resolveComponent("app-select-from-db")
  const _component_el_button = _resolveComponent("el-button")
  const _component_svg_icon = _resolveComponent("svg-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.batchState === 10)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-themes mr-2",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.btnDownloadBalance && _ctx.btnDownloadBalance(...args)))
                  }, " 下载余额 "))
                : _createCommentVNode("", true),
              _createVNode(_component_app_select_from_db, {
                style: {"width":"14rem","height":"1rem"},
                modelValue: _ctx.curBatchId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.curBatchId) = $event)),
                searchApi: _ctx.batchIdSelectApi,
                "onUpdate:changeValue": _ctx.updateBatchID
              }, null, 8, ["modelValue", "searchApi", "onUpdate:changeValue"])
            ]),
            (_ctx.batchState === 20)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  loading: _ctx.isShow,
                  disabled: _ctx.isShow,
                  size: "large",
                  type: "primary",
                  class: "btn-themes float-right",
                  onClick: _ctx.btnUpdateAllData
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.Auth('/attendance/duty/balanceDown/list'))
              ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_10, _hoisted_21, 512)
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.tableItems.length<1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                          _createElementVNode("td", {
                            colspan: _ctx.getTableTrLength(_ctx.$refs.tableTr)
                          }, [
                            _createVNode(_component_svg_icon, { name: "alert" }),
                            _hoisted_24
                          ], 8, _hoisted_23)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.Id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(i + 1), 1),
                        _createElementVNode("td", null, _toDisplayString(item.balanceBatch), 1),
                        _createElementVNode("td", null, _toDisplayString(item.userCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.userName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.balanceValue), 1),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(item.balanceUse), 1),
                        _createElementVNode("td", null, _toDisplayString(item.createName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.createTime), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyTime), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}